const config = {
	formFields: [
		{
			label: 'Sitemap',
			description: 'upload a sitemap.xml file',
			// tooltip: '',
			name: 'sitemap',
			type: 'file',
			value: null,
			// attributes: 'accept=".xml"',
			// pattern: '',
			// default: '',
			rowHeight: '70px'
		},
		{
			label: 'Robots',
			description: 'upload a robots.txt file',
			// tooltip: '',
			name: 'robots',
			type: 'file',
			value: null,
			// pattern: '',
			// default: '',
			// attributes: 'accept=".txt"',
			rowHeight: '70px'
		}
	],
	globals: {
		project: {
			fields: [
				{
					label: 'Languages',
					description: '__globals.project.language -- active languages and default language for website interface',
					// tooltip: '',
					name: 'project.language.list[]',
					type: 'container',
					model: 'languagesInserter',
					value: '',
					tempItems: [],
					default: '',
					// pattern: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				{
					label: 'Currencies',
					description: '__globals.project.currency -- active currencies, default displayed currency and provider currency to be used on the platform',
					// tooltip: '',
					name: 'project.currency.list[]',
					type: 'container',
					model: 'currenciesInserter',
					value: '',
					tempItems: [],
					display: '',
					provider: '',
					// pattern: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				{
					label: 'Enable Level-Based Render',
					description: '__globals.project.enableLevelBasedRender -- render snippets level by level, instead of parent-children deep',
					tooltip: 'careful with this setting, since it can trigger unwanted behaviour on certain pages',
					name: 'project.enableLevelBasedRender',
					type: 'checkbox',
					model: 'enableLevelBasedRender',
					value: '',
					condition: {
						urlParam: 'experimental'
					},
					falseValue: '0',
					trueValue: '1',
					default: '',
					// pattern: '',
					// attributes: '',
					rowHeight: '70px'
				},
				{
					label: 'Enable the use of minified PostScripts file',
					description: '__globals.project.enablePostScriptsFile -- use the minified PostScripts file containing all dynamic snippets postScripts',
					tooltip: 'using one single file implies the snippets scripts cannot be defined as anonymous modules, so each module definition should use a specific id (eg: name of snippet)',
					name: 'project.enablePostScriptsFile',
					type: 'checkbox',
					model: 'enablePostScriptsFile',
					value: '',
					falseValue: '0',
					trueValue: '1',
					default: '',
					// pattern: '',
					// attributes: '',
					rowHeight: '70px'
				},
				{
					label: 'Custom init event',
					description: '__globals.project.customInitProp -- set a custom Event name that the app will wait for, in order to start the page rendering. Leave empty for default behaviour. If set, you will need to make sure that you trigger an event with this name, from somewhere inside a snippet js script, using the globally available doEvent(\'eventName\') function, otherwise the pages won\'t be rendering. Prior to that, you can do and make sure other async requests are finished, so all needed data is available once the rendering is started',
					// tooltip: '',
					name: 'project.customInitProp',
					type: 'text',
					model: 'customInitProp',
					value: '',
					pattern: '[A-z0-9]*',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				// {
				//     label: 'Prerequisites',
				//     // description: '',
				//     // tooltip: '',
				//     type: 'text',
				//     name: 'project.prerequisites',
				//     model: 'prerequisites',
				//     condition: {
				//         urlSubstring: 'elamys'
				//     },
				//     // pattern: '[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]',
				//     // default: '',
				//     // attributes: '',
				//     rowHeight: '70px',
				//     value: '',
				//     defaultValue: JSON.stringify({
				//         'aidaPackages': {
				//             'list': null,
				//             'filters': null,
				//             'selectedItem': null
				//         },
				//         'entities': {
				//             'list': null,
				//             'filters': null,
				//             'selectedItem': null
				//         },
				//         'events': {
				//             'list': null,
				//             'filters': null,
				//             'selectedItem': null
				//         },
				//         'destinationName': '',
				//     }),
				// }
				{
					label: 'Developer Mode',
					description: '__globals.project.developerMode - enable developer mode flags',
					// tooltip: '',
					name: 'project.developerMode',
					type: 'checkbox',
					model: 'languagesInserter',
					condition: {
						urlParam: 'experimental'
					},
					value: '0',
					falseValue: '0',
					trueValue: '1',
					default: '',
					// pattern: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px',
					trueChildrenFields: [
						{
							label: 'Performance Logs',
							description: '__globals.project.developerSettings.logPerformance -- enable console logs for performance benchmarks',
							// tooltip: '',
							name: 'project.developerSettings.logPerformance',
							type: 'checkbox',
							model: 'languagesInserter',
							condition: {
								urlParam: 'experimental'
							},
							value: '0',
							falseValue: '0',
							trueValue: '1',
							default: '',
							// pattern: '',
							// attributes: 'accept=".txt"',
							rowHeight: '70px'
						},
						{
							label: 'Rendering Logs',
							description: '__globals.project.developerSettings.logRendering -- enable console logs for page rendering stats',
							// tooltip: '',
							name: 'project.developerSettings.logRendering',
							type: 'checkbox',
							model: 'languagesInserter',
							condition: {
								urlParam: 'experimental'
							},
							value: '0',
							falseValue: '0',
							trueValue: '1',
							default: '',
							// pattern: '',
							// attributes: 'accept=".txt"',
							rowHeight: '70px'
						},
						{
							label: 'Serialize Search',
							description: '__globals.project.developerSettings.serializeSearch -- enable search serialization for deeplinks generation',
							// tooltip: '',
							name: 'project.developerSettings.serializeSearch',
							type: 'checkbox',
							model: 'languagesInserter',
							condition: {
								urlParam: 'experimental',
								urlSubstring: 'elamys'
							},
							value: '0',
							falseValue: '0',
							trueValue: '1',
							default: '',
							// pattern: '',
							// attributes: 'accept=".txt"',
							rowHeight: '70px'
						}
					]
				},
				{
					label: 'Custom decloaking',
					description: '__globals.project.decloakingBlocked -- block the default decloaking process so the __app.utils.decloak method can be used inside a postScript to control the timing of the page reveal',
					tooltip: 'IMPORTANT: if checked, the decloaking has to be manually run inside snippets postScripts running __app.utils.decloak method. For example binding to a `[snippetName]-rendered` event: onEvent(\'header-rendered\', __app.utils.decloak)',
					name: 'project.decloakingBlocked',
					type: 'checkbox',
					model: 'decloakingBlocked',
					// condition: {
					//     urlParam: 'experimental'
					// },
					value: '',
					falseValue: '0',
					trueValue: '1',
					default: '',
					// pattern: '',
					// attributes: '',
					rowHeight: '70px'
				},
				{
					label: 'Decloaking duration',
					description: '__globals.project.decloakingDuration -- time it takes for the `decloaking` class to be removed from body, after decloak process has started, mainly for animating purposes',
					tooltip: 'remember you can also manually start decloaking process using __app.utils.decloak method',
					name: 'project.decloakingDuration',
					type: 'text',
					model: 'decloakingDuration',
					// condition: {
					//     urlParam: 'experimental'
					// },
					value: '',
					default: '',
					placeholder: 'defaults to 600 (ms)',
					// pattern: '',
					// attributes: '',
					rowHeight: '70px'
				},
				{
					label: 'Decloak Snippet/Delay',
					description: '__globals.project.decloakSnippet -- name of the last rendered snippet before decloaking the page',
					tooltip: 'use snippet name or snippet order number. Using a number above 100, will act as the delay time (in ms) to be used before decloaking the page',
					name: 'project.decloakSnippet',
					type: 'text',
					model: 'decloakSnippet',
					// condition: {
					//     urlParam: 'experimental'
					// },
					value: '',
					default: '',
					placeholder: 'snippet name, order number or timeout > 100 ms',
					// pattern: '',
					// attributes: '',
					rowHeight: '70px'
				}
			]
		},
		client: {
			fields: [
				{
					label: 'Admin Email',
					description: '__globals.client.adminEmail -- email address for admin notifications',
					// tooltip: '',
					name: 'client.adminEmail',
					type: 'email',
					value: null,
					// pattern: '[a-z0-9]+@[a-z]+\.[a-z]{2,3}',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				{
					label: 'Production Environment',
					description: '__globals.client.productionEnv -- boolean value to enable live production environment',
					// tooltip: '',
					name: 'client.productionEnv',
					type: 'checkbox',
					trueValue: '1',
					falseValue: '0',
					// type: 'select',
					// selectOptions: {
					//     '0': 'No',
					//     '1': 'Yes'
					// },
					value: '',
					// trueValue: 1,
					// falseValue: 0,
					defaultValue: '',
					// pattern: '',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				{
					label: 'Payment Gateway',
					description: '__globals.client.paymentGateway -- payment gateway used for online payment',
					tooltip: 'for multiple options use a comma separator (eg: paytrail,saferpay)',
					name: 'client.paymentGateway',
					type: 'text',
					value: null,
					pattern: '^[0-9a-zA-Z]+(,[0-9a-zA-Z]+)*$',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				{
					label: 'Google Maps Key',
					description: '__globals.client.googleMapsKey -- key for googleMaps linked to your google account',
					// tooltip: '',
					name: 'client.googleMapsKey',
					type: 'text',
					value: null,
					autocomplete: 'on',
					// pattern: '[0-9A-Za-z\\-_]{38}',
					pattern: 'AIza[0-9A-Za-z\\-_]{35}',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				{
					label: 'Facebook App Id',
					description: '__globals.client.fbAppId -- the app id received from facebook APIs',
					// tooltip: '',
					name: 'client.fbAppId',
					type: 'text',
					value: null,
					// pattern: '',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				}
				// {
				//     label: 'Pages path',
				//     description: 'url segment from server domain to actual website root folder',
				//     tooltip: 'eg: /published/',
				//     name: 'client.pages_path',
				//     type: 'text',
				//     value: null,
				//     trueValue: 1,
				//     falseValue: 0,
				//     defaultValue: 0,
				//     // pattern: '',
				//     // default: '',
				//     // attributes: 'accept=".txt"',
				//     rowHeight: '70px'
				// }
			]
		},
		app: {
			fields: [
				// {
				//     label: 'Application Name',
				//     description: '__globals.app.name -- Application Name used for API requests)',
				//     name: 'app.name',
				//     name: 'appName',
				//     type: 'text',
				//     value: '',
				//     defaultValue: 'TRIP',
				//     pattern: '[A-z0-9]*',
				//     // default: '',
				//     // attributes: 'accept=".txt"',
				//     rowHeight: '70px'
				// },
				// {
				//     label: 'Application Id',
				//     description: '__globals.app.application_id -- Application Id used for API requests)',
				//     name: 'app.application_id',
				//     name: 'applicationId',
				//     type: 'text',
				//     value: '',
				//     defaultValue: 'cms_sandbox',
				//     pattern: '[A-z0-9]*',
				//     // default: '',
				//     // attributes: 'accept=".txt"',
				//     rowHeight: '70px'
				// },
				{
					label: 'Services',
					description: '__globals.app.services -- enabled services',
					name: 'app.services[]',
					type: 'container',
					value: '',
					tempItems: [],
					selectOptions: {
						'flight': 'Flights',
						'hotel': 'Hotels',
						'activity': 'Activities',
						'package': 'AIDA Packages',
						'flight_hotel': 'Flight + Hotel'
					},
					// pattern: '',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				// {
				//     label: 'CID',
				//     description: 'container IDs for the searches',
				//     name: 'app.CID',
				//     type: 'container',
				//     value: '',
				//     tempItems: [],
				//     selectOptions: {
				//         'hotel': 'hCID',
				//         'flight': 'fCID'
				//     }
				// },
				// {
				//     label: 'ApplicationId',
				//     description: 'Application Id used for requests',
				//     name: 'app.application_id',
				//     type: 'text',
				//     value: 'cms_sandbox',
				//     defaultValue: 'cms_sandbox',
				//     // pattern: '',
				//     // default: '',
				//     // attributes: 'accept=".txt"',
				//     rowHeight: '70px'
				// },
				// {
				//     label: 'App Name',
				//     description: 'app name',
				//     name: 'app.name',
				//     type: 'text',
				//     value: 'TRIP',
				//     defaultValue: 'TRIP',
				//     // pattern: '',
				//     // default: '',
				//     // attributes: 'accept=".txt"',
				//     rowHeight: '70px'
				// },
				{
					label: 'Nationality Id',
					description: '__globals.app.nationality -- Nationality Id from IRIX (used for hotel searches)',
					name: 'app.nationality',
					type: 'dynamic-select',
					url: '/static-data/nationalities',
					dataPath: 'data._embedded.nationalities',
					valueProp: 'Id',
					displayProp: 'Name',
					value: '',
					// defaultValue: '',
					// pattern: '[0-9]*',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				},
				{
					label: 'App Version Number',
					description: '__globals.app.version -- version number associated with latest update or modifications (this is automatically used for requiring postScripts)',
					tooltip: 'this number will be used when loading the latest dynamic snippets and scripts. Format: year_last_digit.month_number.day+patch_number (eg: 2.5.231)',
					name: 'app.version',
					type: 'text',
					value: '',
					pattern: '[0-9]+(.[0-9]+)*$',
					// value: '' + ('' + new Date().getFullYear()).slice(-1) + '.' + (new Date().getMonth() + 1) + '.' + new Date().getDate() + '1',
					// defaultValue: '' + ('' + new Date().getFullYear()).slice(-1) + '.' + (new Date().getMonth() + 1) + '.' + new Date().getDate() + '1',
					// value: '' + moment().format('Y').slice(-1) + '.' + moment().format('M') + '.' + moment().format('D') + '1',
					// defaultValue: '' + moment().format('Y').slice(-1) + '.' + moment().format('M') + '.' + moment().format('D') + '1',
					// pattern: '',
					// default: '',
					// attributes: 'accept=".txt"',
					rowHeight: '70px'
				}
			]
		},
		custom: {
			fields: []
		}
	}
}

export default config
